<template>
  <el-row class="articleContent" ref="print" id="print">
    <el-col :span="24">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="margin-top-10"
      >
        <el-breadcrumb-item>{{ upList.announceType }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ upList.articleTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="printButton">
        <el-button class="themeButton" @click="pri" icon="el-icon-printer"
          >打印本页</el-button
        >
      </div>
<!--      <div-->
<!--        class="borderCo"-->
<!--        v-show="-->
<!--          upList.classId == '04'-->
<!--            ? true-->
<!--            : false || this.$route.query.type == 1-->
<!--            ? false-->
<!--            : true || this.$route.query.type == 2-->
<!--            ? false-->
<!--            : true-->
<!--        "-->
<!--      >-->
      <div
          class="borderCo"
          v-show="
          upList.announceType === '办件结果公开'
          || upList.announceType === '博物馆管理'
          || upList.announceType === '文物进出境'
          || upList.announceType === '文物保护'
          || upList.announceType === '考古发掘'
          || upList.channelId === '5ba3aedc-7063-4b5c-9147-9312844c324c'
          "
      >
        <el-row>
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              索引号
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              : {{ upList.indexNum }}
            </div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              信息分类
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              : {{ upList.themeTypeNames }}
            </div></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              发文机构
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              : {{ upList.sourceName }}
            </div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              成文日期
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              : {{ upList.writtenTime | formatDate }}
            </div></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              发文字号
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              : {{ upList.numa + upList.numb + upList.numc }}
            </div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              发布日期
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              : {{ upList.publishTime | formatDate }}
            </div></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              标题
            </div></el-col
          >
          <el-col :span="20"
            ><div class="grid-content bg-purple-light">
              : {{ upList.articleTitle }}
            </div></el-col
          >
        </el-row>
      </div>
      <div class="printContent">
        <p class="readCountLabel">
          浏览次数：<span class="readCount">{{
            upList.visits ? upList.visits : 0
          }}</span>
        </p>
        <p class="contentHeader">{{ upList.articleTitle }}</p>
        <div class="content" id="content"></div>
      </div>
      <div class="printButton">
        <el-button class="themeButton" @click="pri" icon="el-icon-printer"
          >打印本页</el-button
        >
      </div>
    </el-col>
  </el-row>
</template>

<script>
import util from "../../utils/util";
export default {
  name: "ArticleContent",
  data() {
    return {
      upList: [],
    };
  },
  mounted() {
    this.getList(this.$route.query.id);
  },
  filters: {
    formatDate: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
      }
    },
  },
  methods: {
    pri() {
      this.$print(this.$refs.print);
    },
    // 获取数据列表
    getList(val) {
      let Url = util.getAjaxUrl("axiosThree");
      this.$http.get(Url + `/api/es/find/one?id=${val}`).then((res) => {
        console.log(res.data)
        if (res.status == 200) {
          if (res.data.code == 200) {
            console.log(res,'res.data');
            // themeTypeNames
            let tabulation = res.data.data.articleInfo;
            // 将数组字符串 转化为用“，”分割开的字符串
            // tabulation.themeTypeNames = tabulation.messageType.join(",");
            tabulation.themeTypeNames = tabulation.messageType;
            this.upList = tabulation;
            let list = document.getElementById("content");
            list.innerHTML = tabulation.content;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
.articleContent {
  width: 96%;
  margin: 0 auto;
  padding-top: 10px;
  .printButton {
    width: 100%;
    display: flow-root;
    margin: 20px 0;
  }
  .themeButton {
    background-color: @theme-color;
    border-color: @theme-color;
    color: #ffffff;
    padding: 9px 15px;
    float: right;
    font-size: 12px;
    vertical-align: top;
  }
  .themeButton:hover {
    background-color: #c54949;
  }
  .readCountLabel {
    text-align: right;
    padding-right: 10px;
    margin: 10px 0 15px;
    font-size: 12px;
  }
  .readCount {
    color: #ec1d1d;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .contentHeader {
    color: #ec1d1d;
    border-bottom: 1px solid #ec1d1d;
    font-size: 22px;
    margin-top: 10px !important;
    padding-bottom: 10px;
    text-align: center;
    line-height: 38px;
    font-weight: 700;
  }
  .content {
    overflow: hidden;
    margin: 15px 0;
    font-size: 12px;
    border-bottom: 1px solid #303133;
  }
  .flex {
    display: inline-block;
    width: 90%;
    // margin: 0 auto;
    // margin-left: 5%;
    // padding-right: 5%;
    text-align: center;
    .el-button {
      width: 88px;
      height: 32px;
      line-height: 5px;
      text-align: center;
      padding: 0;
    }
    .el-button:hover {
      color: #7c2121;
      border-color: #b71c1c;
      background-color: #f8e8e8;
    }
    .el-button:active {
      color: #7c2121;
      border-color: #7c2121;
    }
    .el-button:focus {
      color: #7c2121;
      border-color: #b71c1c;
      background-color: #f8e8e8;
    }
  }
  .borderCo {
    padding: 10px;
    border: 1px solid #beac88;
    font-size: 14px;
    line-height: 2;
    color: #303133;
  }
}
el-col {
  margin: 10px 0;
}
</style>
